import styled, { keyframes } from 'styled-components';
import COLORS from '../../utils/Colors';
import { NAVBAR_HEIGHT } from '../../utils/constants';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const PageContainer = styled.div`
    display: grid;
    width: 100vw;
    position: fixed;
    grid-template-columns: 60% 40%;
    padding-top: ${NAVBAR_HEIGHT};
    font-family: 'Inter', sans-serif;

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        grid-template-columns: 100% 0%;
    };
`;

export const InfoSide = styled.div`
    overflow: auto;
    max-height: 100vh;
    background-color: ${COLORS.freshaWhite};
    border-right: 1px solid ${COLORS.freshaGray200};
`;

export const MapSide = styled.div`
    background-color: #fff;
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
    gap: 1.5rem;
`;

export const Spinner = styled.div`
    border: 4px solid #f3f4f6;
    border-top: 4px solid ${COLORS.brandPurple};
    border-radius: 50%;
    width: 3rem;
    height: 3rem;
    animation: ${spin} 0.8s linear infinite;
`;

export const LoadingText = styled.p`
    font-size: 1.125rem;
    color: #6b7280;
    font-weight: 500;
    margin: 0;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
    gap: 1rem;
    padding: 2rem;
    text-align: center;
`;

export const EmptyIcon = styled.div`
    font-size: 4rem;
    margin-bottom: 1rem;
`;

export const EmptyTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 700;
    color: #111827;
    margin: 0;
`;

export const EmptyText = styled.p`
    font-size: 1rem;
    color: #6b7280;
    margin: 0;
`;

export const MessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
    gap: 1rem;
    padding: 2rem;
    text-align: center;
`;

export const Message = styled.p`
    font-size: 1.25rem;
    color: #374151;
    font-weight: 500;
    margin: 0;
`;

export const SubMessage = styled.p`
    font-size: 1rem;
    color: #6b7280;
    margin: 0;
    max-width: 32rem;
`;

export const ErrorMessage = styled.p`
    font-size: 1.25rem;
    color: #dc2626;
    font-weight: 500;
    margin: 0;
`;